import type React from "react";
import { createContext, useCallback, useMemo, useState } from "react";
import type { AlertColor } from "@mui/material/Alert";

type SnackbarProps = {
  open: boolean;
  message: string;
  severity?: AlertColor;
};

export type SnackbarContext = {
  snackbar: SnackbarProps;
  setSnackbar: React.Dispatch<React.SetStateAction<SnackbarProps>>;
  onClose: () => void;
};

const defaultValue: SnackbarContext = {
  snackbar: {
    open: false,
    message: "",
  },
  setSnackbar: () => {},
  onClose: () => {},
};

/**
 * ローディング状態を管理する
 */
export const SnackbarContext = createContext(defaultValue);

export const SnackbarProvider = ({ children }: { children: React.ReactNode }) => {
  const [snackbar, setSnackbar] = useState<SnackbarProps>({
    open: false,
    message: "",
  });

  const onClose = useCallback(() => {
    setSnackbar({
      open: false,
      message: "",
    });
  }, []);

  const value = useMemo(() => ({ snackbar, setSnackbar, onClose }), [snackbar, onClose]);

  return <SnackbarContext.Provider value={value}>{children}</SnackbarContext.Provider>;
};
